import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';
import type { Aporte, Familiar, MiEmpresa } from '../types';

/** Lee una vista del afiliado. Si falla, tira el error para que react-query lo exponga. */
async function leerVista<T>(vista: string, orden: { col: string; asc: boolean }): Promise<T[]> {
  const { data, error } = await supabase.from(vista).select('*').order(orden.col, { ascending: orden.asc });
  if (error) throw error;
  return (data ?? []) as T[];
}

export function useMisEmpresas() {
  return useQuery({
    queryKey: ['mis-empresas'],
    queryFn: () => leerVista<MiEmpresa>('vw_mis_empresas', { col: 'fecha_alta', asc: false }),
  });
}

export function useMiGrupoFamiliar() {
  return useQuery({
    queryKey: ['mi-grupo-familiar'],
    queryFn: () => leerVista<Familiar>('vw_mi_grupo_familiar', { col: 'fecha_nacimiento', asc: true }),
  });
}

/** Solo el monto aportado por periodo: la vista no expone la remuneracion (ADR #048). */
export function useMisAportes() {
  return useQuery({
    queryKey: ['mis-aportes'],
    queryFn: () => leerVista<Aporte>('vw_mis_aportes', { col: 'periodo', asc: false }),
  });
}
